<template>
  <component
    class="hkl-text"
    :is="component"
    v-bind="$attrs"
  >{{ text }}</component>
</template>

<script>
/**
 * @example
 * ```html
 * <HKLText text="Test"/>
 * => <span>Test</span>
 * ```
 * @example
 * ```html
 * <HKLText :component="div" text="Test"/>
 * => <div>Test</div>
 * ```
 * @example
 * ```html
 * <HKLText :component="HKLCheckbox" text="Test"/>
 * => <HKLCheckbox>Test</HKLCheckbox>
 * ```
 */
export default {
  props: {
    text: {
      default: '',
    },
    component: {
      default: 'span',
    },
  },
}
</script>
